import React from 'react';
import Theme from './theme/Theme';
import Person from './pages/Person';

export default function App() {
  return (
    <Theme>
      <Person />
    </Theme>
  );
}
